import React, { useCallback } from 'react';

import { OrientationEnum } from 'ud-ui/components/fabric-canvas/addons/placeholders/complex/team-period-fouls';
import Selector from '../../../elements/selector';
import UDText from 'ud-ui/components/text';
import history from 'ud-ui/components/fabric-canvas/addons/history';
import { selectFabricManager } from '../../../../../store/editor/selectors';
import { useSelector } from 'react-redux';

interface IProps {
  onChange: (orientation: OrientationEnum) => void;
  value: OrientationEnum;
}

function ChoosingOrientation(props: IProps) {
  const { onChange, value } = props;
  const manager = useSelector(selectFabricManager);

  const onFocusField = useCallback(() => {
    manager?.render();
    history.saveState();
  }, [manager]);

  return (
    <>
      <UDText type={'caption-1'}>Ориентация</UDText>
      <Selector
        onFocus={onFocusField}
        onChange={(event) => {
          onChange(event?.value);
        }}
        options={options}
        value={options.find((option) => option.value === value)}
      />
    </>
  );
}

export default ChoosingOrientation;

const options = [
  { label: 'По горизонтали', value: OrientationEnum.HORIZONTAL },
  { label: 'По вертикали', value: OrientationEnum.VERTICAL },
];
